module.exports = __webpack_public_path__ + "img/itsm8.2b5cbc08.png";